module.exports = __webpack_public_path__ + "media/src/website/images/locations/kufstein/kufstein_03-32f055cf9ac11cb0c8cd404253d2e474.jpg";